/*
  LAMIXO cart page (21 Oct 2026). Works with sections/lamixo-cart.liquid.
  - Quantity -/+ and remove: /cart/change.js, then the cart body is redrawn
    from the server (Section Rendering API) so totals are always Shopify's.
  - Adding from the picks grid (quick add) also redraws the cart.
  - "Explore LAMIXO picks": related products for every product in the cart
    (Shopify recommendations, rendered with the default LAMIXO card through
    sections/lamixo-cart-recs), merged, cart items removed, shuffled; then
    the cart items' own categories (cat: tags), then their departments
    (grp: tags), then best sellers. 40 at a time behind "Show more".
  - Select all / per item, All / Selected tabs, Manage cart (bulk delete),
    Share cart (pop-up with link, copy and apps; the link opens a
    "Shared cart" view to pick and add the items). Summary and shipping
    bar follow the selection.
  - Order minimum (AED 100, from #lmxup-data in sections/lamixo-cart): while
    the selected items are under it, the top bar shows "Add AED X more to
    reach the AED 100 order minimum" with a progress bar, and a matching line
    sits above Checkout. At or over it, the free-shipping bar comes back. Checkout
    takes only the selected items: the rest are held in localStorage and
    added back by assets/lamixo-hold.js on the next storefront page.
*/
(function () {
  if (window.__lmxCart) return;
  window.__lmxCart = 1;

  function root() { return document.querySelector('.lmxct'); }
  function sectionId() {
    var r = root(), s = r && r.closest('.shopify-section');
    return s ? s.id.replace(/^shopify-section-/, '') : null;
  }
  function badge(count) {
    if (window.LMXQA && window.LMXQA.setBadge) { window.LMXQA.setBadge(count); return; }
    var b = document.querySelector('.lmxh a[href="/cart"] b');
    if (b) b.textContent = count;
  }

  var refreshing = null;
  function refresh() {
    var id = sectionId();
    if (!id) return Promise.resolve();
    refreshing = fetch('/cart?sections=' + encodeURIComponent(id), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var doc = new DOMParser().parseFromString(j[id] || '', 'text/html');
        var nb = doc.querySelector('.lmxct-body'), ob = document.querySelector('.lmxct-body');
        if (nb && ob) ob.replaceWith(nb);
        var nr = doc.querySelector('.lmxct'), r = root();
        if (nr && r) {
          ['data-ids', 'data-handles', 'data-cartdisc'].forEach(function (a) { r.setAttribute(a, nr.getAttribute(a) || ''); });
        }
        apply();
      })
      .catch(function () { location.reload(); });
    return refreshing;
  }

  function change(item, qty) {
    var key = item.getAttribute('data-key');
    item.classList.add('is-busy');
    fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (cart) { badge(cart.item_count); return refresh(); })
      .catch(function (e) {
        item.classList.remove('is-busy');
        var p = item.querySelector('.lmxct-err');
        if (p) { p.textContent = (e && (e.description || e.message)) || 'Could not update this item.'; p.hidden = false; }
      });
  }

  document.addEventListener('click', function (e) {
    var item = e.target.closest && e.target.closest('.lmxct-item');
    if (!item || item.classList.contains('is-busy')) return;
    var cur = parseInt(item.getAttribute('data-qty'), 10) || 1;
    if (e.target.closest('.lmxct-del')) { e.preventDefault(); change(item, 0); return; }
    var d = e.target.closest('[data-d]');
    if (d) { e.preventDefault(); change(item, Math.max(0, cur + (+d.getAttribute('data-d')))); }
  });

  /* quick add from the picks grid (or anywhere) -> redraw the cart */
  document.addEventListener('cart:update', function (e) {
    var src = e.detail && (e.detail.sourceId || (e.detail.data && e.detail.data.source));
    if (src === 'lmxqa' && root()) refresh();
  });

  /* ---------- selection, tabs, manage, share, held checkout ---------- */
  var OFF = 'lmxCartOff', HOLD = 'lmxCartHold', view = 'all', manage = false;
  function lsGet(k) { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function lsSet(k, v) { try { if (v == null) localStorage.removeItem(k); else localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  var off = lsGet(OFF) || [];
  function items() { return [].slice.call(document.querySelectorAll('.lmxct-item')); }
  function keyOf(li) { return li.getAttribute('data-key'); }
  function isOn(li) { return off.indexOf(keyOf(li)) < 0; }
  function num(li, a) { return parseInt(li.getAttribute(a), 10) || 0; }
  function fmt(c) { return 'AED' + (c / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function setAll(sel, fn) { [].forEach.call(document.querySelectorAll(sel), fn); }
  function post(url, body) {
    return fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function note(msg) {
    var t = document.createElement('div');
    t.className = 'lmxct-toast'; t.textContent = msg;
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-in'); });
    setTimeout(function () { t.classList.remove('is-in'); setTimeout(function () { t.remove(); }, 300); }, 2200);
  }
  var TRUCK = '<svg width="20" height="16" viewBox="0 0 24 18" fill="currentColor" aria-hidden="true"><path d="M.9 2.4h11.4c.7 0 1.2.5 1.2 1.2v8.2H2.1c-.7 0-1.2-.5-1.2-1.2V2.4Z"/><path d="M14.6 5.4h3.8c.4 0 .8.2 1 .5l2.7 3.2c.2.2.3.5.3.8v1.9h-7.8V5.4Z"/><circle cx="6.6" cy="14" r="2.5"/><circle cx="17.4" cy="14" r="2.5"/></svg>';
  var BAG = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M5 8h14l-1 12.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 6 20.5L5 8Z" stroke-linejoin="round"/><path d="M9 10V6.5a3 3 0 0 1 6 0V10" stroke-linecap="round"/></svg>';
  function minOrder() {
    var n = document.getElementById('lmxup-data');
    try { return +JSON.parse(n.textContent).min || 0; } catch (e) { return 0; }
  }
  var TICK = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function apply() {
    var r = root(), all = items();
    if (!r || !all.length) return;
    if (!lsGet(HOLD)) {
      var keys = all.map(keyOf);
      off = off.filter(function (k) { return keys.indexOf(k) > -1; });
      lsSet(OFF, off.length ? off : null);
    }
    var sel = all.filter(isOn);
    all.forEach(function (li) {
      var on = isOn(li), cb = li.querySelector('.lmxct-pick input');
      li.classList.toggle('is-on', on);
      if (cb) cb.checked = on;
    });
    var ab = r.querySelector('[data-all]');
    if (ab) { ab.checked = sel.length === all.length; ab.indeterminate = sel.length > 0 && sel.length < all.length; }
    setAll('[data-c-all]', function (n) { n.textContent = all.length; });
    setAll('[data-c-sel]', function (n) { n.textContent = sel.length; });
    setAll('[data-c-del]', function (n) { n.textContent = sel.length; });
    setAll('.lmxct-tab', function (b) { b.classList.toggle('is-on', b.getAttribute('data-view') === view); });
    var list = r.querySelector('.lmxct-items');
    if (list) list.classList.toggle('is-sel', view === 'sel');
    r.classList.toggle('is-manage', manage);
    var mb = r.querySelector('.lmxct-manage');
    if (mb) mb.hidden = !manage;
    var db = r.querySelector('[data-act="del"]');
    if (db) db.disabled = !sel.length;

    var qty = 0, orig = 0, fin = 0;
    sel.forEach(function (li) { qty += num(li, 'data-qty'); orig += num(li, 'data-orig'); fin += num(li, 'data-final'); });
    var sub = fin - (sel.length === all.length ? (parseInt(r.getAttribute('data-cartdisc'), 10) || 0) : 0);
    if (orig < sub) orig = sub;
    var saved = orig - sub, FREE = 20000, ship = (!sel.length || sub >= FREE) ? 0 : 2000, total = sub + ship;
    function v(name, html) { setAll('.lmxct-sum [data-v="' + name + '"]', function (n) { n.innerHTML = html; }); }
    setAll('.lmxct-sum [data-r="save"]', function (n) { n.hidden = saved <= 0; });
    v('orig', fmt(orig)); v('save', '-' + fmt(saved)); v('sub', fmt(sub));
    v('ship', ship ? fmt(ship) : '<b class="is-free">FREE</b>');
    v('total', fmt(total)); v('inst', fmt(Math.floor(total / 4)));
    var cta = r.querySelector('.lmxct-sum [data-v="cta"]');
    if (cta) {
      cta.disabled = !sel.length;
      cta.innerHTML = !sel.length ? '<b>Select items to checkout</b>'
        : saved > 0 ? '<b>You save ' + Math.floor(saved * 100 / orig) + '% today</b><small>Checkout (' + qty + ')</small>'
        : '<b>Checkout (' + qty + ')</b>';
    }
    /* minimum: checked on the subtotal BEFORE order discounts (fin), the same
       number the "Order minimum AED 100" checkout rule uses */
    var MINO = minOrder(), minLeft = sel.length ? MINO - fin : 0;
    r.setAttribute('data-minsub', sel.length ? fin : 0);
    var ml = r.querySelector('.lmxct-sum [data-v="minline"]');
    if (ml) {
      ml.hidden = minLeft <= 0;
      if (minLeft > 0) ml.innerHTML = '<p><b>' + fmt(minLeft) + '</b> away from the ' + fmt(MINO) + ' order minimum</p>' +
        '<i class="lmxct-bar"><i style="width:' + Math.min(100, Math.floor(fin * 100 / MINO)) + '%"></i></i>';
    }
    var sw = r.querySelector('.lmxct-shipwrap');
    if (sw) {
      if (minLeft > 0) {
        sw.innerHTML = '<div class="lmxct-ship lmxct-min">' + BAG + '<div class="lmxct-ship-t"><span>Add <b>' + fmt(minLeft) +
          '</b> more to reach the <b>' + fmt(MINO) + ' order minimum</b></span><i class="lmxct-bar"><i style="width:' +
          Math.min(100, Math.floor(fin * 100 / MINO)) + '%"></i></i></div>' +
          '<a href="/collections/best-selling-items">Add items &rsaquo;</a></div>';
      } else if (sel.length && sub < FREE) {
        var pct = Math.min(100, Math.floor(sub * 100 / FREE));
        sw.innerHTML = '<div class="lmxct-ship">' + TRUCK + '<div class="lmxct-ship-t"><span>Add <b>' + fmt(FREE - sub) +
          '</b> more for <b>FREE shipping</b></span><i class="lmxct-bar"><i style="width:' + pct + '%"></i></i></div>' +
          '<a href="/collections/best-selling-items">Add items &rsaquo;</a></div>';
      } else {
        sw.innerHTML = '<div class="lmxct-ship is-free">' + TICK + '<span>' +
          (sel.length ? '<b>Free shipping</b> on all selected items' : '<b>Free shipping</b> on orders over AED 200') +
          '</span><em>Free returns within 7 days</em></div>';
      }
    }
  }

  function closeMenu() {
    setAll('.lmxct-menu-p', function (p) { p.hidden = true; });
    setAll('[data-menu]', function (b) { b.setAttribute('aria-expanded', 'false'); });
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t.closest || !t.closest('.lmxct') || t.closest('.lmxct-shared')) return;
    if (t.matches('[data-all]')) {
      off = t.checked ? [] : items().map(keyOf);
    } else if (t.closest('.lmxct-pick')) {
      var k = keyOf(t.closest('.lmxct-item'));
      off = off.filter(function (x) { return x !== k; });
      if (!t.checked) off.push(k);
    } else return;
    lsSet(OFF, off.length ? off : null);
    apply();
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var mb = e.target.closest('[data-menu]');
    if (mb) {
      var pop = mb.parentNode.querySelector('.lmxct-menu-p'), open = pop.hidden;
      closeMenu();
      pop.hidden = !open; mb.setAttribute('aria-expanded', String(open));
      return;
    }
    if (!e.target.closest('.lmxct-menu-p')) closeMenu();
    var tab = e.target.closest('[data-view]');
    if (tab) { view = tab.getAttribute('data-view'); apply(); return; }
    var act = e.target.closest('[data-act]');
    if (!act) return;
    var a = act.getAttribute('data-act');
    closeMenu();
    if (a === 'manage') { manage = true; apply(); }
    else if (a === 'done') { manage = false; apply(); }
    else if (a === 'del') {
      var upd = {}, sel = items().filter(isOn);
      if (!sel.length) return;
      sel.forEach(function (li) { upd[keyOf(li)] = 0; li.classList.add('is-busy'); });
      post('/cart/update.js', { updates: upd })
        .then(function (cart) { badge(cart.item_count); manage = false; return refresh(); })
        .catch(function () { location.reload(); });
    } else if (a === 'share') {
      var all = items(), keys = all.filter(isOn).map(keyOf);
      if (!keys.length) keys = all.map(keyOf);
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
        var parts = cart.items.filter(function (it) { return keys.indexOf(it.key) > -1; })
          .map(function (it) { return it.handle + '~' + it.variant_id + '~' + it.quantity; });
        if (!parts.length) return;
        shareModal(location.origin + '/cart?lmxshare=' + parts.join(','), parts.length);
      }).catch(function () { note('Could not create the link. Please try again.'); });
    }
  });

  /* checkout only what is selected; hold the rest */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.classList || !f.classList.contains('lmxct-co')) return;
    var all = items(), sel = all.filter(isOn);
    if (!sel.length) { e.preventDefault(); return; }
    if (sel.length === all.length) return;
    e.preventDefault();
    var un = all.filter(function (li) { return !isOn(li); }), upd = {};
    var hold = un.map(function (li) {
      var props = {};
      try { props = JSON.parse(li.getAttribute('data-props') || '{}') || {}; } catch (x) {}
      upd[keyOf(li)] = 0;
      return { id: num(li, 'data-vid'), quantity: num(li, 'data-qty') || 1, properties: props };
    });
    var cta = f.querySelector('[data-v="cta"]');
    if (cta) cta.disabled = true;
    lsSet(HOLD, { items: hold, t: Date.now() });
    post('/cart/update.js', { updates: upd })
      .then(function () { location.href = '/checkout'; })
      .catch(function () { lsSet(HOLD, null); if (cta) cta.disabled = false; location.reload(); });
  }, true);

  /* ---------- share pop-up (Temu style): link + copy + apps ---------- */
  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function copyText(input, text) {
    var ok = false;
    try { input.focus(); input.select(); input.setSelectionRange(0, text.length); ok = document.execCommand('copy'); } catch (e) {}
    try { if (navigator.clipboard) navigator.clipboard.writeText(text).catch(function () {}); } catch (e) {}
    return ok;
  }
  var SHARE_APPS = [
    ['WhatsApp', '#25d366', 'https://wa.me/?text={T}%20{U}', '<path d="M12 3a9 9 0 0 0-7.8 13.5L3 21l4.6-1.2A9 9 0 1 0 12 3Z" fill="none" stroke="#fff" stroke-width="1.8"/><path d="M9 8.2c.2-.4.5-.4.7-.4h.5c.2 0 .4.1.5.4l.7 1.6c.1.2 0 .5-.1.6l-.5.6c-.1.1-.1.3 0 .5.6 1 1.4 1.8 2.4 2.4.2.1.4.1.5 0l.6-.6c.2-.2.4-.2.6-.1l1.6.8c.2.1.3.3.3.5v.4c0 .3-.1.6-.4.8-.6.4-1.4.6-2.1.4-2.6-.8-4.6-2.8-5.4-5.4-.2-.7 0-1.5.4-2.1Z" fill="#fff"/>'],
    ['Facebook', '#1877f2', 'https://www.facebook.com/sharer/sharer.php?u={U}', '<path d="M13.2 21v-7.5h2.5l.4-3h-2.9V8.6c0-.9.3-1.4 1.5-1.4h1.5V4.5c-.3 0-1.2-.1-2.2-.1-2.2 0-3.6 1.3-3.6 3.7v2.4H8v3h2.4V21h2.8Z" fill="#fff"/>'],
    ['X', '#111', 'https://twitter.com/intent/tweet?text={T}&url={U}', '<path d="M5 4h4l3.4 4.7L16.5 4H19l-5.4 6.3L19.6 20h-4l-3.7-5.1L7.4 20H5l5.7-6.6L5 4Z" fill="#fff"/>'],
    ['Telegram', '#229ed9', 'https://t.me/share/url?url={U}&text={T}', '<path d="M4 11.6 19.5 5.3c.7-.3 1.3.2 1.1 1l-2.7 12.6c-.2.8-.7 1-1.4.6l-3.8-2.8-1.8 1.8c-.2.2-.4.3-.8.3l.3-3.9 7-6.4c.3-.3-.1-.4-.5-.2l-8.7 5.5-3.7-1.2c-.8-.2-.8-.8.2-1.2Z" fill="#fff"/>'],
    ['Email', '#6b6b6b', 'mailto:?subject={T}&body={U}', '<rect x="4" y="6" width="16" height="12" rx="2" fill="none" stroke="#fff" stroke-width="1.8"/><path d="m5 7.5 7 5.5 7-5.5" fill="none" stroke="#fff" stroke-width="1.8"/>']
  ];
  function shareModal(url, n) {
    var old = document.querySelector('.lmxct-shm');
    if (old) old.remove();
    var text = 'Check out my LAMIXO cart';
    var ov = document.createElement('div');
    ov.className = 'lmxct-shm';
    ov.innerHTML =
      '<div class="lmxct-shm-d" role="dialog" aria-modal="true" aria-label="Share cart">' +
        '<button type="button" class="lmxct-shm-x" aria-label="Close">&times;</button>' +
        '<h3>Share your cart</h3>' +
        '<p>Anyone with this link will see these ' + n + ' item' + (n > 1 ? 's' : '') + ' and can add them to their own cart.</p>' +
        '<div class="lmxct-shm-apps">' + SHARE_APPS.map(function (a) {
          var href = a[2].replace('{U}', encodeURIComponent(url)).replace('{T}', encodeURIComponent(text));
          return '<a href="' + esc(href) + '" target="_blank" rel="noopener"><i style="background:' + a[1] + '"><svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">' + a[3] + '</svg></i><span>' + a[0] + '</span></a>';
        }).join('') +
        (navigator.share ? '<a href="#" data-native><i style="background:#ff5a00"><svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true"><circle cx="6" cy="12" r="2.2" fill="#fff"/><circle cx="17" cy="6" r="2.2" fill="#fff"/><circle cx="17" cy="18" r="2.2" fill="#fff"/><path d="m8 11 7-4M8 13l7 4" stroke="#fff" stroke-width="1.6"/></svg></i><span>More</span></a>' : '') +
        '</div>' +
        '<div class="lmxct-shm-row"><input type="text" readonly value="' + esc(url) + '" aria-label="Cart link"><button type="button" data-copy>Copy link</button></div>' +
      '</div>';
    document.body.appendChild(ov);
    var input = ov.querySelector('input'), cb = ov.querySelector('[data-copy]');
    function close() { ov.remove(); document.removeEventListener('keydown', onKey); }
    function onKey(e) { if (e.key === 'Escape') close(); }
    document.addEventListener('keydown', onKey);
    ov.addEventListener('click', function (e) {
      if (e.target === ov || e.target.closest('.lmxct-shm-x')) { close(); return; }
      if (e.target.closest('[data-copy]')) {
        copyText(input, url);
        cb.textContent = 'Copied!'; cb.classList.add('is-done');
        setTimeout(function () { cb.textContent = 'Copy link'; cb.classList.remove('is-done'); }, 1800);
        return;
      }
      var nat = e.target.closest('[data-native]');
      if (nat) { e.preventDefault(); navigator.share({ title: text, url: url }).catch(function () {}); }
    });
    input.addEventListener('focus', function () { input.select(); });
  }

  /* ---------- a shared cart link: /cart?lmxshare=handle~variant~qty,...
     Opens a "Shared cart" view (like Temu): the shared items with photo,
     options and price; the visitor ticks what they want and adds it to
     their own cart. Old links (variant:qty) are simply added. */
  function sharedView(spec) {
    var r = root();
    var list = spec.split(',').map(function (x) {
      var a = x.split('~');
      return a.length === 3 ? { h: a[0], id: parseInt(a[1], 10), q: Math.min(99, Math.max(1, parseInt(a[2], 10) || 1)) } : null;
    }).filter(function (x) { return x && x.h && x.id; });
    if (!r || !list.length) return false;
    r.classList.add('is-shared');
    var box = document.createElement('section');
    box.className = 'lmxct-shared';
    box.innerHTML =
      '<div class="lmxct-sh-head">' +
        '<i aria-hidden="true"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><path d="M3 4h2.2l2.1 10.2a1.6 1.6 0 0 0 1.6 1.3h7.7a1.6 1.6 0 0 0 1.6-1.2L20 8H6.2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="10" cy="20" r="1.3" fill="currentColor"/><circle cx="17" cy="20" r="1.3" fill="currentColor"/></svg></i>' +
        '<div><h1>A friend shared their cart with you</h1><p>Pick the items you like and add them to your cart in one tap.</p></div>' +
      '</div>' +
      '<div class="lmxct-sh-grid"><ul class="lmxct-sh-list"><li class="lmxct-sh-load">Loading the shared items…</li></ul>' +
      '<aside class="lmxct-sh-sum">' +
        '<label class="lmxct-chk lmxct-allbox"><input type="checkbox" checked data-sh-all><i></i><span>Select all</span></label>' +
        '<div class="lmxct-total"><span>Selected (<b data-sh-n>0</b>)</span><b data-sh-total>AED0.00</b></div>' +
        '<button type="button" class="lmxct-cta" data-sh-add><b>Add to my cart</b></button>' +
        '<p class="lmxct-sh-msg" hidden></p>' +
        '<a class="lmxct-sh-mine" href="/cart">View my cart ›</a>' +
      '</aside></div>';
    r.insertBefore(box, r.querySelector('.lmxct-body'));
    var ul = box.querySelector('.lmxct-sh-list'), btn = box.querySelector('[data-sh-add]'), msg = box.querySelector('.lmxct-sh-msg');
    function rows() { return [].slice.call(ul.querySelectorAll('.lmxct-sh-it:not(.is-out)')); }
    function sum() {
      var on = rows().filter(function (li) { return li.querySelector('input').checked; }), t = 0, n = 0;
      on.forEach(function (li) { t += num(li, 'data-price') * num(li, 'data-q'); n += num(li, 'data-q'); });
      box.querySelector('[data-sh-n]').textContent = n;
      box.querySelector('[data-sh-total]').textContent = fmt(t);
      var all = box.querySelector('[data-sh-all]');
      all.checked = on.length && on.length === rows().length; all.indeterminate = on.length > 0 && on.length < rows().length;
      btn.disabled = !on.length;
      btn.innerHTML = on.length ? '<b>Add to my cart (' + n + ')</b>' : '<b>Select items to add</b>';
    }
    var handles = list.map(function (x) { return x.h; }).filter(function (h, i, a) { return a.indexOf(h) === i; });
    Promise.all(handles.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
        .then(function (res) { return res.ok ? res.json() : null; }).catch(function () { return null; });
    })).then(function (prods) {
      var html = list.map(function (x) {
        var p = prods[handles.indexOf(x.h)], v = p && p.variants.filter(function (vv) { return vv.id === x.id; })[0];
        if (!p || !v) return '';
        var im = (v.featured_image && v.featured_image.src) || p.featured_image || '';
        if (im.indexOf('//') === 0) im = 'https:' + im;
        var was = v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price : 0;
        return '<li class="lmxct-sh-it' + (v.available ? '' : ' is-out') + '" data-id="' + v.id + '" data-q="' + x.q + '" data-price="' + v.price + '">' +
          '<label class="lmxct-chk lmxct-pick"><input type="checkbox"' + (v.available ? ' checked' : ' disabled') + ' aria-label="Select ' + esc(p.title) + '"><i></i></label>' +
          '<a class="lmxct-img" href="/products/' + esc(p.handle) + '?variant=' + v.id + '">' + (im ? '<img src="' + esc(im) + (im.indexOf('?') > -1 ? '&' : '?') + 'width=260" alt="" loading="lazy">' : '') +
            (v.available ? '' : '<span class="lmxct-low">SOLD OUT</span>') + '</a>' +
          '<div class="lmxct-info">' +
            '<a class="lmxct-title" href="/products/' + esc(p.handle) + '?variant=' + v.id + '">' + esc(p.title) + '</a>' +
            (v.title && v.title !== 'Default Title' ? '<span class="lmxct-var">' + esc(v.title) + '</span>' : '') +
            '<div class="lmxct-row"><div class="lmxct-price">' + (was ? '<s>' + fmt(was) + '</s>' : '') + '<b>' + fmt(v.price) + '</b></div>' +
            '<span class="lmxct-sh-q">Qty ' + x.q + '</span></div>' +
          '</div></li>';
      }).join('');
      ul.innerHTML = html || '<li class="lmxct-sh-load">These items are no longer available.</li>';
      sum();
    });
    box.addEventListener('change', function (e) {
      if (e.target.matches('[data-sh-all]')) rows().forEach(function (li) { li.querySelector('input').checked = e.target.checked; });
      sum();
    });
    btn.addEventListener('click', function () {
      var on = rows().filter(function (li) { return li.querySelector('input').checked; });
      if (!on.length) return;
      btn.disabled = true; btn.innerHTML = '<b>Adding…</b>';
      var ok = 0, chain = Promise.resolve();
      on.forEach(function (li) {
        chain = chain.then(function () {
          return post('/cart/add.js', { items: [{ id: num(li, 'data-id'), quantity: num(li, 'data-q') }] })
            .then(function () { ok++; })
            .catch(function () {
              /* not enough stock for that quantity: add what can be added */
              return post('/cart/add.js', { items: [{ id: num(li, 'data-id'), quantity: 1 }] }).then(function () { ok++; }).catch(function () {});
            });
        });
      });
      chain.then(function () {
        if (!ok) {
          msg.textContent = 'Sorry, these items are out of stock right now.'; msg.hidden = false;
          sum(); return;
        }
        location.href = '/cart';
      });
    });
    return true;
  }
  (function () {
    var sp = new URLSearchParams(location.search).get('lmxshare');
    if (!sp) return;
    if (sp.indexOf('~') > -1) {
      var go = function () { sharedView(sp); };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
      return;
    }
    history.replaceState(null, '', location.pathname);
    var chain = Promise.resolve();
    sp.split(',').forEach(function (pair) {
      var a = pair.split(':'), id = parseInt(a[0], 10), q = Math.min(99, Math.max(1, parseInt(a[1], 10) || 1));
      if (id) chain = chain.then(function () { return post('/cart/add.js', { items: [{ id: id, quantity: q }] }).catch(function () {}); });
    });
    chain.then(function () { location.reload(); });
  })();

  /* ---------- Explore LAMIXO picks ----------
     Order: related products for everything in the cart (shuffled together),
     then the cart items' categories mixed, then their departments mixed,
     then best sellers. 40 cards at a time. Same paging
     as the department pages: a "Show more" button, and once it has been
     pressed, more load as the shopper scrolls near the end. The button goes
     only when there is nothing left. Cart items and duplicates never show. */
  function shuffle(a) {
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1)), t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }
  function pathOf(a) {
    try { return new URL(a.getAttribute('href'), location.origin).pathname.replace(/^\/collections\/[^/]+/, ''); }
    catch (e) { return a.getAttribute('href'); }
  }
  function cardsIn(html) {
    if (!html) return [];
    var d = new DOMParser().parseFromString(html, 'text/html');
    var pg = d.querySelector('.lmxct-pages');
    var list = [].slice.call(d.querySelectorAll('a.lmx-card')).map(function (n) { return document.importNode(n, true); });
    list.pages = pg ? parseInt(pg.getAttribute('data-pages'), 10) || 1 : null;
    return list;
  }
  function get(url) {
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .catch(function () { return ''; });
  }

  var PAGE = 40;
  function tagList(r, attr, pre) {
    var out = [];
    (r.getAttribute(attr) || '').split(',').forEach(function (t) {
      t = t.trim();
      if (t.indexOf(pre) === 0) { t = t.slice(pre.length); if (t && out.indexOf(t) < 0) out.push(t); }
    });
    return out;
  }

  function picks() {
    var r = root();
    if (!r) return;
    var sec = r.querySelector('.lmxct-recs');
    var grid = r.querySelector('.lmxct-recs-g');
    var more = r.querySelector('.lmxct-more');
    var btn = more && more.querySelector('[data-more]');
    var sent = r.querySelector('.lmxct-sent');
    if (!grid || grid.getAttribute('data-ready')) return;
    grid.setAttribute('data-ready', '1');

    var ids = (r.getAttribute('data-ids') || '').split(',').filter(Boolean);
    var inCart = (r.getAttribute('data-handles') || '').split(',').filter(Boolean)
      .map(function (h) { return '/products/' + h; });
    var seen = {}, pool = [], done = false, loading = false, autoOn = false;
    function src(h) { return { h: h, page: 0, pages: 1, done: false }; }
    var tiers = [
      tagList(r, 'data-cats', 'cat:').map(src),
      tagList(r, 'data-grps', 'grp:').map(src),
      [src('best-selling-items')]
    ], tier = 0;

    function keep(cards) {
      cards.forEach(function (c) {
        var p = pathOf(c);
        if (seen[p] || inCart.indexOf(p) > -1) return;
        seen[p] = 1; pool.push(c);
      });
    }
    /* next page of every source in the current tier, mixed together.
       In-stock items only (store filter), 40 cards per page. */
    function fetchFallback() {
      while (tier < tiers.length && tiers[tier].every(function (x) { return x.done; })) tier++;
      if (tier >= tiers.length) { done = true; return Promise.resolve([]); }
      var act = tiers[tier].filter(function (x) { return !x.done; });
      return Promise.all(act.map(function (x) {
        x.page++;
        return get('/collections/' + encodeURIComponent(x.h) + '?filter.v.availability=1&page=' + x.page + '&section_id=lamixo-cart-recs').then(function (html) {
          var list = cardsIn(html);
          if (list.pages) x.pages = list.pages;
          if (!html || !list.length || x.page >= x.pages) x.done = true;
          return list;
        });
      })).then(function (lists) { return [].concat.apply([], lists); });
    }
    function moreFallback() {
      return fetchFallback().then(function (cards) { keep(shuffle(cards)); });
    }
    function fillTo(n) {
      if (pool.length >= n || done) return Promise.resolve();
      return moreFallback().then(function () { return fillTo(n); });
    }
    function sync() {
      if (more) more.hidden = !(pool.length || !done);
      sec.classList.toggle('is-empty', !grid.children.length && done && !pool.length);
    }
    function showNext() {
      if (loading) return Promise.resolve();
      loading = true;
      if (btn) btn.disabled = true;
      return fillTo(PAGE).then(function () {
        pool.splice(0, PAGE).forEach(function (c) { grid.appendChild(c); });
        return fillTo(1);
      }).then(function () {
        loading = false;
        if (btn) btn.disabled = false;
        sync();
      });
    }

    if (btn) btn.addEventListener('click', function () { autoOn = true; showNext(); });
    if (sent && window.IntersectionObserver) {
      new IntersectionObserver(function (es) {
        if (autoOn && es[0].isIntersecting && (pool.length || !done)) showNext();
      }, { rootMargin: '600px 0px' }).observe(sent);
    }

    /* the category pages are fetched at the same time as the related
       products (one round trip instead of two); related still go first */
    var early = fetchFallback();
    Promise.all(ids.slice(0, 8).map(function (id) {
      return get('/recommendations/products?product_id=' + encodeURIComponent(id) + '&limit=10&intent=related&section_id=lamixo-cart-recs');
    })).then(function (pages) {
      var related = [];
      pages.forEach(function (html) { related = related.concat(cardsIn(html)); });
      keep(shuffle(related));
      return early;
    }).then(function (cards) {
      keep(shuffle(cards));
      return showNext();
    });
  }

  function start() { apply(); picks(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
